// Libraries
import { Box, DrawerCloseButton } from '@chakra-ui/react';
import styled from '@emotion/styled';

export const StyledDrawerCloseButton = styled(DrawerCloseButton)(({ theme }) => ({
  position: 'absolute',
  left: '-24px',
  top: '0',
  borderRadius: '0',
  width: '24px',
  height: '24px',
  padding: '6px',
  background: theme.colors.neutral['323846'],
  color: theme.colors.common.white,
}));

export const TabButtonsContainer = styled.div(({ theme }) => ({
  position: 'absolute',
  top: '40px',
  left: '-96px',
}));

export const TabButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '8px',
  justifyContent: 'center',
  width: '96px',
  height: '72px',
  cursor: 'pointer',
  background: theme.colors.surface.F5F7F9,
  boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.12), 0px 4px 4px 3px rgba(0, 0, 0, 0.08)',
  borderRadius: '4px 0 0 4px',
  transition: '0.3s',

  '& svg': {
    width: '20px',
    height: '20px',
    color: theme.colors.text.g2,
    marginBottom: '2px',
  },

  '& p': {
    color: theme.colors.text.g2,
  },

  '&:hover': {
    background: theme.colors.surface.E6F1FD,

    '& svg': {
      color: theme.colors.button.blue.focus,
    },

    '& p': {
      color: theme.colors.button.blue.focus,
    },
  },

  '&.selected': {
    width: '108px',
    marginLeft: '-12px',
    background: theme.colors.surface.E6F1FD,

    '& svg': {
      color: theme.colors.button.blue.focus,
    },

    '& p': {
      color: theme.colors.button.blue.focus,
    },
  },
}));

export const ExtendedSidepanel = styled.div(({ theme }) => ({
  position: 'absolute',
  top: '0',
  left: '100%',
  background: '#fff',
  width: '100%',
  display: 'flex',
  height: '100vh',
  overflow: 'auto',
}));
